<template>
  <div class="base-checkbox">
    <input
      type="checkbox"
      :id="id"
      :value="value || id"
      :disabled="disabled"
      v-model="checkboxValue"
    />
    <label
      :for="id"
      :class="labelClass"
      :style="labelStyle"
      v-html="label"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseCheckbox',

  props: {
    id: {
      type: [String, Number],
      required: true
    },
    modelValue: {
      type: [Boolean, Array],
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: [String, Number],
      default: ''
    },
    value: {
      type: [String, Number],
      default: null
    },
    disabled: Boolean,
    labelStyle: String,
    labelClass: String
  },

  emits: ['update:modelValue', 'update:checked'],

  computed: {
    checkboxValue: {
      get() {
        return this.modelValue || this.checked;
      },
      set(value) {
        this.$emit('update:modelValue', value);
        this.$emit('update:checked', value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/design/mainIncludes";

.base-checkbox {
  input {
    display: none;
  }

  label {
    padding-left: 32px;
    font-size: 15px;
    line-height: 26px;
    position: relative;
    display: block;
    pointer-events: none;

    &::before {
      content: "";
      position: absolute;
      display: inline-block;
      width: 24px;
      height: 24px;
      left: 0;
      top: 0;
      border-radius: 4px;
      border: 1px solid $grey-4;
      background: #fff no-repeat center;
      background-size: 14px;
      transition: all 0.2s;
      cursor: pointer;
      pointer-events: auto;
    }

    :deep a {
      font-size: inherit;
      font-weight: 500;
      color: $green-5;
      pointer-events: auto;
    }
  }

  input:checked + label::before {
    background-image: url("@public/check-icon.svg");
    border-color: #009440;
    background-color: #009440;
  }
}
</style>